import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import ValidationError from "~/Components/Forms/ValidationError";
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import {ArrowBackIcon, ChevronRight, EditIcon} from "~/Components/Icons/Icons";
import classnames from "classnames";
import {Link} from "react-router-dom";
import Translated from "~/Admin/AdminMultilang/Translated";


const AdminEventFaq = ({match, event, onChange, ...props}) => {

    const [selectedId, setSelectedId] = useState(0);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');

    const defaultForm = {
        question: '',
        answer: '',
        display_order: 0,
        translations: {}
    };

    const [form, setForm] = useState(defaultForm);

    useEffect(() => {

        const selectedItem = event.faqs.find((f) => f.id === selectedId);

        setError(null);
        setMessage('');

        if (selectedItem) {
            setForm({
                question: selectedItem.question,
                answer: selectedItem.answer,
                display_order: selectedItem.display_order,
                translations: selectedItem.translations,
            });
        } else {
            setForm(defaultForm);
        }

    } , [selectedId]);

    const handleAdd = () => {
        adminHttp
            .post('/events/' + event.id + '/faqs', form)
            .then(res => {
                setError(null);
                setMessage('Saved successfully!');
                onChange();
            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    };

    const handleUpdate = () => {
        adminHttp
            .put('/events/' + event.id + '/faqs/' + selectedId, form)
            .then(res => {
                setError(null);
                setMessage('Saved successfully!');

                onChange();

            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    };

    const handleDelete = () => {
        adminHttp
            .delete('/events/' + event.id + '/faqs/' + selectedId)
            .then(res => {
                setError(null);
                setMessage('');
                onChange();
            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    }

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setForm({...form, [name]: value});
    };

    const selectedItem = event.faqs.find((f) => f.id === selectedId);

    return (
        <div>
            <div className="card shadow-sm bg-white">
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">

                            {selectedItem && (
                                <a onClick={() => setSelectedId(0)} className="btn btn-secondary btn-sm mb-4">
                                    <ArrowBackIcon classes="d-inline mr-2"/>
                                    Back
                                </a>
                            )}

                            <h3>{selectedItem ? 'Edit FAQ #' + selectedId : 'New FAQ'}</h3>

                            {message && (
                                <div className="alert alert-success" role="alert">
                                    {message}
                                </div>
                            )}

                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error.message || "Error saving faq!"}
                                </div>
                            )}

                            <div className="form-group required">
                                <label className="d-block">Question</label>

                                <Translated translations={form.translations}
                                            enabled={!!selectedItem}
                                            onChanged={(values) => setForm({...form, translations: values})}>
                                    <input
                                        onChange={handleChange}
                                        value={form.question}
                                        name="question"
                                        className="form-control"/>
                                </Translated>

                                <ValidationError errors={error?.errors} name="question"/>
                            </div>

                            <div className="form-group required">
                                <label className="d-block">Answer</label>

                                <Translated translations={form.translations}
                                            enabled={!!selectedItem}
                                            onChanged={(values) => setForm({...form, translations: values})}>
                                    <textarea
                                        onChange={handleChange}
                                        value={form.answer}
                                        name="answer"
                                        className="form-control"/>
                                </Translated>

                                <ValidationError errors={error?.errors} name="answer"/>
                            </div>

                            <div className="form-group">
                                <label className="d-block">Display Order</label>

                                <input
                                    onChange={handleChange}
                                    value={form.display_order}
                                    name="display_order"
                                    className="form-control"/>

                                <ValidationError errors={error?.errors} name="display_order"/>
                            </div>

                            {selectedItem && (
                                <>
                                    <button
                                        onClick={handleUpdate}
                                        className="btn btn-primary text-cta float-right btn-sm">
                                        Update question
                                    </button>

                                    <ConfirmedButton
                                        onClick={handleDelete}
                                        className="btn btn-danger text-cta float-right mr-3 btn-sm">
                                        Delete Question
                                    </ConfirmedButton>
                                </>
                            )}

                            {!selectedItem && (
                                <>
                                    <button
                                        onClick={handleAdd}
                                        className="btn btn-primary text-cta float-right btn-sm">
                                        Create question
                                    </button>
                                </>
                            )}

                        </div>
                    </div>
                </div>
            </div>

            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <h3>Your Frequently Asked Questions</h3>

                            <table className="table">
                                <tbody>
                                {event.faqs?.map((faq) => (
                                    <tr key={faq.id}>
                                        <td>
                                            <span className={classnames({'font-weight-bold' : faq.id === selectedId})}>{faq.question}</span>
                                        </td>
                                        <td>
                                            <a className="cursor-pointer float-right" onClick={(e) => setSelectedId(faq.id)}>
                                                <EditIcon />
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventFaq);
